<template>
  <div>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="true" />
    <v-snackbar v-model="snackbar" :location="'top'" :multi-line="false" :timeout="6000" :vertical="false">
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">Close</v-btn>         
      </template>
    </v-snackbar>
    <v-card prepend-icon="mdi-cog" style="padding-right: 0px;">
      <template v-slot:title>
        <h3 class="text-black">Settings</h3>
      </template>
    </v-card>

    <!-- <v-expansion-panel v-model="expanded">
      <v-expansion-panel-content>-->
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            <h4 class="text-black" style="margin-left: -8px;">Order Options</h4>
            <!-- <v-switch
                  class="swtich"
                  v-model="expanded"
                  v-bind:label="expanded?'on':'off'"
                  v-on:change="filterChange()"
                  ></v-switch> -->
          </v-col>
          <v-col style="text-align: right;">
            <span class="position_right">
              <v-btn color="success" @click="saveConfiguration()">Save</v-btn>
              <!-- <v-btn small color="error" @click="cancel()">Cancel</v-btn> -->
            </span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider />
    </v-card>
    <!-- <v-divider></v-divider> -->
    <v-layout row>
      <v-col col="12" style="padding: 0px;">
        <v-card>
          <v-card-title style="padding: 7px;">
            <v-row>
              <v-col cols="3" style="text-align: left;padding-right: 0px;">
                <h5 class="text-black">Order remarks configuration</h5>
              </v-col>
              <v-col cols="9" justify-center style="text-align: left;padding-left: 0px;">
                <v-btn @click="refreshList()" variant="text" color="green">
                  <v-icon dark>mdi-refresh</v-icon>Refresh List
                </v-btn>
                <small class="font-weight-light">Last refresh time : {{ refreshTime }}</small>
              </v-col>
            </v-row>
          </v-card-title>
          <!-- <v-card-title style="padding: 7px;">
              <h5 class="text-black">Order remarks configuration</h5>
              <v-btn @click="refreshList()" variant="text" size="small" color="green">
                <v-icon dark>refresh</v-icon>Refresh List
              </v-btn>
              <small class="text-caption">Last refresh time : {{refreshTime}}</small>
            </v-card-title> -->
          <div style="text-align: left; margin-bottom:15px; padding-left: 10px;">
            <em>When using AGRIS Sales app.. the "check marked" remarks listed below will be displayed during Sales Order
              entry for all users. (NOTE: if the remark is check marked and grey this indicates a "REQUIRED" status in
              AGRIS and cannot be un-selected.) </em>
          </div>
          <v-text-field style="padding-top: 0px;" name="input-1-3" label="Search Remarks ID or Label" single-line
            prepend-icon="mdi-magnify" v-model="searchText" @update:model-value="search" variant="underlined"
            color="primary" />
          <div style="text-align: left;margin-bottom: 10px;">
            <v-btn color="info" size="small" variant="outlined" @click="selectAll()"
              style="margin-right: 10px; margin-left:10px">Select All</v-btn>
            <v-btn color="warning" size="small" variant="outlined" @click="unselectAll()">Unselect All</v-btn>
          </div>
          <v-list density="compact" lines="one" style="margin-bottom: 10px !important; padding-bottom: 50px;">
            <!-- <v-subheader>Users</v-subheader> -->
            <v-list-item v-if="searchUsers.length == 0">

              <v-list-item-title>No result found.</v-list-item-title>

            </v-list-item>
            <v-list-item v-for="user in searchUsers" :key="user.ConfigId" @click="user.Visible = !user.Visible"
              :disabled="user.Required" style="height: 10px;">


              <template v-slot:prepend="{ isActive }">
                <v-list-item-action start>
                  <v-checkbox v-model="user.Visible" style="padding-left: 20px !important; " />
                </v-list-item-action>
              </template>
              <v-list-item-title style="padding-bottom: 20px !important; ">
                {{ user.RemarksId }} - {{ user.Label }}
              </v-list-item-title>
              <!-- 
                <v-list-item-action style="padding-left: 10px !important;margin-bottom: 10px !important;">
                  <v-checkbox v-model="user.Visible" readonly />
                </v-list-item-action>

                <v-list-item-title>{{user.RemarksId}} - {{user.Label}}
                </v-list-item-title> -->

            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-layout>
    <!-- </v-expansion-panel-content>
      </v-expansion-panel>-->

  </div>
</template>
<script>
// eslint-disable-next-line
/* eslint-disable */
import DataService from '@/services/data-service';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

const dataService = new DataService();
export default {
  name: 'settings',
  data: () => ({
    snackbar: false,
    expanded: 1,
    snackbarText: '',
    searchText: '',
    searchUsers: [],
    users: [],
    isLoading: false,
    refreshTime: '',
  }),
  created() {
    this.initilize();
  },
  components: {
    Loading,
  },
  methods: {
    initilize() {
      this.refreshTime = localStorage.getItem('SalesOrderRemarksConfiguratinRefreshTime');
      this.isLoading = true;
      this.expanded = localStorage.getItem('enablefilter') === 'true' ? 1 : 0;
      dataService.GetOrderRemarksConfiguration().then((response) => {
        this.users = response;
        this.isLoading = false;
        this.searchUsers = Object.assign([], this.users);
      });
    },
    cancel() {
      this.expanded = 1;
    },
    filterChange() {
      localStorage.setItem('enablefilter', this.expanded);
    },
    saveConfiguration() {
      const isFiltered =
        this.users.filter(user => user.Visible === false).length > 0;
      dataService
        .UpdateOrderRemarksConfiguration(this.users)
        .then((response) => {
          this.snackbar = true;
          this.snackbarText = 'Settings saved successfully';
        })
        .catch((e) => {
          this.snackbar = true;
          this.snackbarText = 'Settings saved failed';
        });
    },
    refreshList() {
      this.isLoading = true;
      dataService
        .SetOrderRemarksConfiguration()
        .then(() => {
          this.isLoading = false;
          this.initilize();
        })
        .catch((e) => {
          this.isLoading = false;
          console.log(e, 'Error SetOrderRemarksConfiguration');
        });
    },
    selectAll() {
      this.searchUsers.forEach((user) => {
        if (!user.Required) {
          user.Visible = true;
        }
      });
    },
    unselectAll() {
      this.searchUsers.forEach((user) => {
        if (!user.Required) {
          user.Visible = false;
        }
      });
    },
    search() {
      this.searchUsers = Object.assign([], this.users);
      this.searchUsers = this.searchUsers.filter((user) => {
        const srch = this.searchText;
        return (
          user.RemarksId.toLowerCase().indexOf(srch.toLowerCase()) !==
          -1 ||
          user.Label.toLowerCase().indexOf(srch.toLowerCase()) !== -1
        );
      });
    },
  },
};
</script>

<style>
.padding_left_20 {
  padding-left: 12px;
}

.v-list {
  height: 400px;
  overflow-y: auto;
}

.text_right {
  text-align: right;
}

.position_right {
  right: 125px;
  position: absolute;
  top: 3px;
}

.v-expansion-panel__header {
  background-color: white;
}

.swtich {
  position: absolute;
  top: -8px;
  right: 57px;
  z-index: 1000;
}

.v-application .primary--text {
  color: #82b1ff !important;
  caret-color: #82b1ff !important;
}

.container {
  width: 100% !important;
  padding: 0px !important;
  margin-right: auto !important;
  margin-left: auto !important;
}
</style>
